import styled from 'styled-components'

export const Input = styled.input`
  appearance: none;
  position: absolute;
  left: 0;
  width: 20px;
  height: 20px;
  margin: 0 10px 0 0;
  border-radius: 50%;
  cursor: inherit;
  flex-shrink: 0;
  outline: none;
  border: 1px solid #c2c7d6;
  transition: 0.2s linear 0s;

  &:after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 1rem;
    height: 1rem;
    background-color: #3a64f8;
    transform: translate(-50%, -50%) scale(0);
    border-radius: 50%;
    transition: transform 0.25s cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  &:checked {
    border-color: #3a64f8 !important;

    &:after {
      transform: translate(-50%, -50%) scale(1);
    }
  }
`

export const Label = styled.label`
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
  width: 100%;
  padding: 0 0 0 30px;

  &:hover > ${Input} {
    border-color: #a3abc2;
  }
`

export const Indicator = styled.span`
  color: #292e3d;
  font-family: Navigo, Arial, Helvetica, sans-serif;
  font-size: 1.4rem;
  line-height: 2rem;
  font-weight: 400;
`
